// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a9396f8e","453":"4f998469","455":"2adf5909","977":"457f4d3f"}[chunkId] + ".chunk.js";
};